import { render, staticRenderFns } from "./baseBox.vue?vue&type=template&id=2c0a77c5&scoped=true&"
import script from "./baseBox.vue?vue&type=script&lang=js&"
export * from "./baseBox.vue?vue&type=script&lang=js&"
import style0 from "./baseBox.vue?vue&type=style&index=0&id=2c0a77c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a77c5",
  null
  
)

export default component.exports